import React from "react";
import { useNavigate, useParams } from "react-router-dom";

import WarmupTimer from "src/components/app/cgm/WarmupTimer";
import Layout from "src/components/app/layout/Layout";
import Header from "../../layout/Header";
import CGMConnectionGuide from "../connection/CGMConnectionGuide";
import CGMConnectVideoTutorials from "../connection/CGMConnectVideoTutorials";
import { Headphones } from "lucide-react";

type WarmupStepProps = {
  warmupEndDate: string;
  onWarmupComplete: () => void;
  handleBack: () => void;
};

const WarmupStep: React.FC<WarmupStepProps> = ({
  warmupEndDate,
  onWarmupComplete,
  handleBack,
}) => {
  const params = useParams();
  const supportProgramKey = params["support-program-key"] ?? "";
  const navigate = useNavigate();
  return (
    <Layout
      supportProgramKey={supportProgramKey}
      className="bg-white"
      containerClassName="bg-white"
      header={
        <Header
          title="Back"
          onBackClick={handleBack}
          rightComponent={
            <button
              className="mr-16 flex items-center gap-2 whitespace-nowrap font-semibold text-[var(--app-primary)]"
              onClick={() =>
                navigate(`/app/${supportProgramKey}/cgm-need-help`)
              }
            >
              <Headphones />
              Need Help?
            </button>
          }
        />
      }
    >
      <div className="flex flex-col items-center w-full">
        <h1 className="pt-4 pb-3 text-2xl font-bold text-[var(--text-primary)]">
          Your Sensor is Warming Up
        </h1>
        <p className="text-sm text-[var(--text-secondary)] opacity-80 mb-6 text-center px-4">
          You have successfully setup your CGM. It will take about an hour for
          your sensor to warm up
        </p>
        <WarmupTimer
          warmupEndDate={warmupEndDate}
          onComplete={onWarmupComplete}
        />
      </div>
      <CGMConnectionGuide />
      <CGMConnectVideoTutorials className="px-4" />
    </Layout>
  );
};

export default WarmupStep;
